// Search over the day: its items, its areas and each area's tutorials. Every term must
// match; title matches rank first, then areas, then items by salience, then tutorials.

const KIND = { paper: "Paper", tutorial: "Tutorial", dataset: "Dataset", blog: "Essay" };
export const kindLabel = kind => KIND[kind] || "Item";
export const fmtZ = z => (z >= 0 ? "+" : "−") + Math.abs(z).toFixed(1);

const text = v => (Array.isArray(v) ? v.join(" ") : v || "");

export function buildIndex(D) {
  const index = [];
  for (const p of D.papers) {
    const a = D.areaById[p.area];
    if (!a) continue;
    index.push({
      type: "paper",
      id: p.id,
      target: p.id,
      title: p.title,
      sub: [a.short || a.name, kindLabel(p.kind), p.minutes && `${p.minutes} min`].filter(Boolean).join(" · "),
      hay: [p.title, p.summary, a.name, text(p.cats), text(p.signals)].join(" ").toLowerCase(),
    });
  }
  for (const a of D.areas) {
    index.push({
      type: "area",
      id: a.id,
      target: a.id,
      title: a.name,
      sub: `${a.today} new today · z ${fmtZ(a.z)}`,
      hay: [a.name, a.short, a.blurb, text(a.cats)].join(" ").toLowerCase(),
    });
    for (const t of a.tutorials || []) {
      index.push({
        type: "tutorial",
        id: `${a.id}:${t.title}`,
        target: a.id,
        title: t.title,
        sub: [a.short || a.name, t.level, t.minutes && `${t.minutes} min`].filter(Boolean).join(" · "),
        hay: [t.title, a.name, t.level, "tutorial"].join(" ").toLowerCase(),
      });
    }
  }
  return index;
}

// An empty query lists the strongest items today.
export function search(index, D, query, limit = 12) {
  const s = query.trim().toLowerCase();
  if (!s) return D.ranked.slice(0, 7).map(p => index.find(r => r.id === p.id)).filter(Boolean);
  const terms = s.split(/\s+/);
  const score = r =>
    (r.title.toLowerCase().includes(s) ? 3 : 0) +
    (r.type === "area" ? 1.6 : r.type === "paper" ? 1 + (D.paperById[r.id]?.salience || 0) : 0.7);
  return index
    .filter(r => terms.every(t => r.hay.includes(t)))
    .map(r => ({ r, s: score(r) }))
    .sort((a, b) => b.s - a.s)
    .slice(0, limit)
    .map(x => x.r);
}
